// frontend/src/components/auth/OnboardingRedirect.tsx
/**
 * OnboardingRedirect - Redirects to dashboard if onboarding is already complete
 * Use this to wrap the onboarding pages themselves
 */

import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/components/providers/auth-provider'



interface OnboardingRedirectProps {
    children: React.ReactNode
}

export function OnboardingRedirect({ children }: OnboardingRedirectProps) {
    const { user, isLoading } = useAuth()
    const navigate = useNavigate()
    const location = useLocation() // Add this import

    useEffect(() => {
        if (isLoading) return

        // If user has completed onboarding AND not on onboarding page, redirect to dashboard
        // This allows them to finish the onboarding flow even after marking complete
        if (user && user.onboarding_completed && !location.pathname.startsWith('/onboarding')) {
            navigate('/app/dashboard', { replace: true })
        }

        if (!isLoading && !user) {
            navigate('/auth/login', { replace: true })
        }
    }, [user, isLoading, navigate, location])

    // Show loading while checking
    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        )
    }

    // Don't redirect if they're still in onboarding flow
    if (!user) {
        return null
    }

    return <>{children}</>
}